import { useEffect, useState } from "react";

const useTypeWriter = (
  text = "Muhammad Sheraz",
  speed = 500,
  indicatorClass = "cursor-indicator"
) => {
  let [str, setStr] = useState("");
  let [index, setIndex] = useState(0);
  useEffect(() => {
    type();
  }, [str]);
  const type = () => {
    if (index < text.length) {
      setTimeout(() => {
        setStr((prev) => (prev += text.charAt(index)));
      }, speed);
      setTimeout(() => {
        document
          .querySelector(`.${indicatorClass}`)
          .classList.toggle("before:hidden");
      }, speed - speed / 2);
      setIndex((prev) => (prev += 1));
    } else {
      setStr(text);
    }
  };

  return { str };
};

export default useTypeWriter;
